import { useEffect } from 'react';
import { images } from '@/api';
import { useAddAlert } from "@/hooks/useAddAlert";

export const useCanvasInit = ({canvasState, canvasRef, canvasOperations, canvasInitParams}) => {
  const { setCtx, setImageUrl, setLoading, setHistory, setScale, scale } = canvasState;
  const { drawImageOnCanvas } = canvasOperations;
  const addAlert = useAddAlert();
  console.log(scale)
  const removeDuplicateSlashes = (url) => {
    return url.replace("///", "/");
  };

  const canvasFunction = (imageUrl) => {
    if (!imageUrl) {
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      setCtx(context);

      const image = new Image();
      image.src = '';
      image.onload = () => {
        drawImageOnCanvas(image);
      }
      return;
    }
    if(canvasInitParams?.initialText) {
      addAlert({ text: canvasInitParams?.initialText });
    }
    setLoading(true);

    const getImgUrl = removeDuplicateSlashes(imageUrl).replace(process.env.REACT_APP_PATH_FILE, "/");
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    setCtx(context);

    images.getAccessCanvas({ imageUrl: getImgUrl })
      .then(({ data }) => {
        const image = new Image();
        image.src = data.contents;
        image.onload = () => {
          drawImageOnCanvas(image);
        }
        if(canvasInitParams?.successText) {
          addAlert({ text: canvasInitParams?.successText });
        }
      })
      .catch(() => {
        addAlert({ title: 'Ошибка', text: 'Попробуйте ещё раз или обратитесь к администратору', type: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetCanvas = () => {
    setScale(1);
    setImageUrl('');
    setHistory([]);
  };

  useEffect(() => {
    setScale(1);
    canvasFunction(canvasState.imageUrl);
  }, [canvasState.imageUrl]);

  return {
    canvasFunction,
    resetCanvas
  };
};